export default function renderRow (printConsignee: boolean, name: string) {
    if (!printConsignee && name === 'Consignee') {
        return false;
    }
    return true;
}
